import React from 'react';
import {
  PropTypes,
  oneOf,
  shape,
  node,
  number,
  string,
  arrayOf
} from 'prop-types';
import LoadingPlaceholder from 'components/loadingPlaceholder/index.js';
import SCPactometroBarras from './pactometroBarras.js';

export const PactometroBarrasSiNo = ({
  totalSeat,
  selecteds,
  selectedsNo,
  centerProps
}) => {
  const seat = selecteds.reduce((acc, item) => acc + item.seats, 0);
  const seatNo = selectedsNo.reduce((acc, item) => acc + item.seats, 0);
  if (!totalSeat) {
    return <LoadingPlaceholder />;
  }

  return (
    <SCPactometroBarras height={50} className="bloque-pactometro-container">
      <div className="bloque-pactometro">
        <p className="bloque-pactometro-seats">
          Total escaños: <span>{totalSeat}</span>
        </p>
        <div
          id="barra"
          className="porcentaje-pactometro bloque-pactometro-barra"
        >
          <div
            className={`mayoria-pactometro-barras ${centerProps.position} ${centerProps.lineStyle}`}
          >
            <p className="bloque-pactometro-opcion bloque-pactometro-opcion--si">
              SÍ: {seat}
            </p>
            <p className="bloque-pactometro-mayoria">
              {centerProps.text || (
                <React.Fragment>
                  Mayoría absoluta:{' '}
                  <span>{parseInt(totalSeat / 2, 0) + 1}</span>
                </React.Fragment>
              )}
            </p>
            <p className="bloque-pactometro-opcion bloque-pactometro-opcion--no">
              NO: {seatNo}
            </p>
          </div>
          {selecteds.map(element => (
            <div
              className="partido partido--left"
              key={element.partyAcronym}
              title={element.partyAcronym}
              style={{
                width: `${(100 / totalSeat) * element.seats}%`,
                backgroundColor: element.partyColor
              }}
            >
              {element.seat}
            </div>
          ))}
          {selectedsNo.map(element => (
            <div
              className="partido partido--right"
              key={element.partyAcronym}
              title={element.partyAcronym}
              style={{
                width: `${(100 / totalSeat) * element.seats}%`,
                backgroundColor: element.partyColor
              }}
            >
              {element.seat}
            </div>
          ))}
        </div>
      </div>
    </SCPactometroBarras>
  );
};
PactometroBarrasSiNo.defaultProps = {
  centerProps: { position: 'down', lineStyle: 'dashed' },
  height: 30
};

PactometroBarrasSiNo.propTypes = {
  height: number,
  title: oneOf([node, string]),
  data: arrayOf(
    shape({
      partyAcronym: string.isRequired,
      seats: number.isRequired,
      partyColor: string.isRequired,
      id: number.isRequired
    })
  ).isRequired,
  selecteds: arrayOf(PropTypes.number),
  selectedsNo: arrayOf(PropTypes.number),
  totalSeat: number,
  centerProps: shape({
    position: oneOf(['up', 'down']),
    lineStyle: oneOf(['dashed', 'solid']),
    text: oneOf([string, node])
  })
};

export default PactometroBarrasSiNo;
